import { useEffect, useState } from 'react';

// Single source of truth for the public launch date. Mirrors the value used
// by the desktop LaunchBanner (Dec 31, 2026, 23:59 JST). Keep in sync.
export const LAUNCH_DATE_ISO = '2026-12-31T23:59:59+09:00';
export const LAUNCH_LABEL = { en: 'Dec 31, 2026', ja: '2026年12月31日' };
const LAUNCH_TS = new Date(LAUNCH_DATE_ISO).getTime();

export function launchCountdown(now = Date.now()) {
  const ms = Math.max(0, LAUNCH_TS - now);
  const total = Math.floor(ms / 1000);
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60,
    isLaunched: ms === 0,
  };
}

// Live countdown hook. Default ticks every second; pass 60000 for day-level UIs.
export function useLaunchCountdown(tickMs = 1000) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), tickMs);
    return () => clearInterval(id);
  }, [tickMs]);
  return launchCountdown(now);
}
